module.exports = _.random;